import {
  request,
  useEndpointsContext,
  type CustomerNetAcquisitionLimitStatus,
  type MarketAccount,
  type MinimalSubscriptionResponse,
} from '@talos/kyoko';
import { useQuery } from '@tanstack/react-query';

const ACQUISITION_LIMIT_STATUS_ID = 'ACQUISITION_LIMIT_STATUS';

const generateAcquisitionLimitStatusQueryID = (marketAccount?: MarketAccount) => {
  return [ACQUISITION_LIMIT_STATUS_ID, '/', marketAccount?.Name];
};

export function useAcquisitionLimitStatusQuery(marketAccount?: MarketAccount) {
  const { orgApiEndpoint } = useEndpointsContext();

  return useQuery<CustomerNetAcquisitionLimitStatus>({
    enabled: !!orgApiEndpoint && !!marketAccount,
    queryKey: generateAcquisitionLimitStatusQueryID(marketAccount),
    queryFn: async () =>
      request<MinimalSubscriptionResponse<CustomerNetAcquisitionLimitStatus>>(
        'GET',
        `${orgApiEndpoint}/customer-risk/net-acquisition/status?MarketAccounts=${marketAccount?.Name}`
      ).then(response => {
        return response.data[0];
      }),
  });
}
